import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
// 必须引入样式，否则组件无样式
import 'element-plus/dist/index.css'
// 引入中文语言包
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import store from './store'

// WangEditor 富文本编辑器样式
import '@wangeditor/editor/dist/css/style.css'

const app = createApp(App)

app.use(store)
    .use(ElementPlus, { locale: zhCn })
    .use(router)
    .mount('#app')
